import { Button, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "../template/store";

const EBLConsent = () => {
  const { loading, data } = useSelector(
    (state: RootState) => state.eblConsentProfile
  );

  if (loading) {
    return <Spinner animation="border" size="sm" className="mt-3" />;
  }

  if (!data || !data.filePath) return null;

  return (
    <div className="position-relative zindex10 mt-4">
      {/* Section Header */}
      <div className="h2 text-secondary fs-0 pb-3 border-bottom">
        Digital eBL Consent
      </div>

      <div className="row align-items-center mb-3">
        <div className="col-lg-8 fs--1 text-muted">
          Digital consent document for handling electronic Bills of Lading (eBL)
        </div>

        <div className="col-lg-4 text-end">
					<Button
					  size="sm"
					  variant="outline-primary"
					  onClick={() =>
					    window.open(data.filePath, "_blank", "noopener,noreferrer")
					  }
					>
					  Download PDF
					</Button>
        </div>
      </div>
    </div>
  );
};

export default EBLConsent;
